import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { openSnackComp }  from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from '@material-ui/core/styles';
import { Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  close: {
    padding: theme.spacing(0.5),
  },
});

class ConsecutiveSnackbars extends React.Component {
  queue = [];

  state = {
    open: false,
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false }, () => { this.props.openSnackComp(false) });
  };

  render() {
    const { classes, message } = this.props;

    return (
      <div>
        <Snackbar
          key={1}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.props.openSnackValue}
          autoHideDuration={5000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

ConsecutiveSnackbars.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => ({
  openSnackValue: store.cardDebitState.openSnackValue,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ openSnackComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConsecutiveSnackbars)
);